import useMutationCall from "../../../hooks/useMutationCall";
import { useRemoveRoleFromEmployeeMutation } from "../employeesSlice";

const useRemoveRoleFromEmployee = () => {
  return useMutationCall(useRemoveRoleFromEmployeeMutation);
};

export default useRemoveRoleFromEmployee;
